module.exports = __webpack_public_path__ + "img/Telegram_onLight.bf9e18ed.svg";